import {
  Accordion, useSections,
} from '~/_shared/baseComponents/accordion';
import type { BoundaryGroupId } from '~/store/boundaries/boundaryIdentifier.type';
import { useBoundaryToolBTGsGroupedByBoundaryGroupSelector } from '~/store/boundaryTerritoryGroups/boundaryTool/boundaryToolBTGs.selectors';
import { BoundaryTerritoryGroupKeyContainer } from './boundaryTerritoryGroupKey.container';

export const BoundaryKey = () => {
  const boundaryTerritoryGroupsByBoundaryGroupId = useBoundaryToolBTGsGroupedByBoundaryGroupSelector();

  const { toggleSection, isExpanded } = useSections<BoundaryGroupId>(
    boundaryTerritoryGroupsByBoundaryGroupId.map(({ boundaryGroupId }) => boundaryGroupId)
  );

  return (
    <Accordion>
      {boundaryTerritoryGroupsByBoundaryGroupId
        .map(({ boundaryGroupId, boundaryTerritoryGroups }) => (
          <BoundaryTerritoryGroupKeyContainer
            key={boundaryGroupId}
            boundaryGroupId={boundaryGroupId}
            boundaryTerritoryGroups={boundaryTerritoryGroups}
            isExpanded={isExpanded(boundaryGroupId)}
            onToggle={() => toggleSection(boundaryGroupId)}
          />
        ))}
    </Accordion>
  );
};
